import { ApiAirline } from "../api/ApiAirline";

export const addAirline = async (addData) => {
  try {
    const data = await ApiAirline().addAirline(
      {
        ...addData
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const updateAirline = async (updateData) => {
  try {
    const data = await ApiAirline().updateAirline(
      {
        ...updateData
      }
    );

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getAirlines = async () => {
  try {
    const data  = await ApiAirline().getAirline();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getAirlineById = async (id) => {
  try {
    const data  = await ApiAirline().getAirlineById(id);

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const getAirlineOptions = async () => {
  try {
    const data  = await ApiAirline().getAirlineOptions();

    if (data.success) {
      return { success: true, data: data.response };
    } else {
      return { success: false, data: data.errors };
    }
  } catch (error) {
    return { success: false, data: error };
  }
};

export const deleteAirline = async (airlineId) => {
  try {
    // Make the DELETE request to delete the user
    const data = await ApiAirline().deleteAirline(airlineId);

    if (data.success) {
      return { success: true, message: data.message };
    } else {
      return { success: false, message: data.errors };
    }
  } catch (error) {
    console.error("Error deleting user:", error);
    return { success: false, message: "An error occurred while deleting the user" };
  }
};